const initialState = {
  loginUrl: false,
};

const LoginRouteReducer = (state = initialState, action) => {
  switch (action.type) {

        case "Login_URL":
        return {
          loginUrl: action.payload.loginUrl
        };
  

    default:
      return state;
  }
};
export default LoginRouteReducer;
